import Vue from 'vue'

// 滚动加载更多
Vue.directive('selectLoadMore', {
    bind(el, binding) {
      // 获取element，定义scroll
      let select_dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
      select_dom.addEventListener('scroll', function (e) {
        let height = this.scrollHeight - this.scrollTop <= this.clientHeight;
        let [fun,name,props='']=binding.value
        if (height) {
            fun(name,props,e)
        }
      })
    }
  });
  